<ng-container class="container" *ngIf="dispatchDetails">
  <div class="dispatch-id" [attr.title]="dispatchDetails.orderNumber" i18n>
    Dispatch #{{dispatchDetails.orderNumber}}
  </div>
  <div class="arrived-at" [innerHTML]="dispatchDetails.dispatchSummary.summary"></div>
  <div class="timeline">
     <ng-container *ngFor="let dispatchStop of dispatchDetails?.dispatchStops">
         <dispatch-step class="completed" [ngClass]="{
            'only-pickup': dispatchStop.stopType === 'pickup',
            'not-last-touched': isDispatchDeparted(dispatchStop),
            'only-dropoff': dispatchStop.stopType === 'dropoff',
            'touched': (dispatchStop.status === 'arrived' || dispatchStop.status === 'departed'),
            'inprogress': dispatchStop.isCurrentLocation && dispatchStop.status !== 'departed'}"
           [dispatchStop]="dispatchStop" [showDateTimeStats]="false"></dispatch-step>
        </ng-container>
  </div>
</ng-container>
